import React, { useMemo } from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import Image from '../../../../../components/pdf/Image'

import { getImages, findReplyByQuestionName, getReplyValue } from '../../_helpers/pdfHelpers'

const AttachmentsSection = ({ certify }) => {
  const certifyImages = useMemo(() => {
    if (!certify || !certify.length) {
      return []
    }

    const reply = getReplyValue(findReplyByQuestionName(certify[0].replies, 'Qual o tipo de equipamento?'))
    if (reply.name === 'Outros') {
      const temperatura = getImages(
        findReplyByQuestionName(certify[0].replies, 'Temperatura e umidade - Incluir imagem do certificado [foto]')
      )
      const iluminancia = getImages(
        findReplyByQuestionName(certify[0].replies, 'Iluminância - Incluir imagem do certificado [foto]')
      )
      const ruido = getImages(
        findReplyByQuestionName(certify[0].replies, 'Ruído - Incluir imagem do certificado [foto]')
      )
      return [ruido[0], iluminancia[0], temperatura[0]]
    }
    return getImages(findReplyByQuestionName(certify[0].replies, 'Incluir imagem do certificado'))
  }, [certify])

  return (
    <View id="8">
      <View pageBreakAfter>
        <Text bold size="small" id={'8'}>
          8 ANEXOS
        </Text>
        <Text bold align={'center'} id={'8.1'}>
          ANEXO I – ANEXO COVID 19
        </Text>
        <Text>
          Em cumprimento a Portaria Conjunta nº 20, de 18 de junho 2020, que estabelece as medidas a serem observadas
          visando à prevenção, controle e mitigação dos riscos de transmissão da COVID-19 nos ambientes de trabalho, o
          Unimed adotou processos e condutas médicas para mitigar e garantir a prevenção ao COVID-19, desde o início da
          pandemia.
        </Text>
        <Text>
          Em 14 de fevereiro o Brasil ainda não apresentava transmissão comunitária para o COVID, e a Unimed iniciou seu
          protocolo isolando viajantes que retornavam de países de risco por até 14 dias, independente da presença de
          sintomas, na tentativa de mitigar circulação de pessoas potencialmente infectadas. Além disso, as viagens a
          trabalho internacionais foram canceladas, mesmo antes do fechamento de fronteiras no Brasil, limitando
          inclusive as viagens nacionais.
        </Text>
        <Text>
          A partir da confirmação do status de transmissão comunitária do COVID-19 no Brasil na segunda quinzena de
          fevereiro, o Banco passou a mapear todos os casos com sintomas gripais e àqueles que se identificassem como
          contatantes e suspeitos de casos positivos, procedia-se com o afastamento preventivo independente de exame
          clínico, com finalidade de contribuir para minimizar a circulação de potenciais casos infectantes da doença ou
          de qualquer outra infecção viral de início semelhante.
        </Text>
        <Text>
          O Banco teve medidas de diminuição de pessoal circulante: fechamento de agências, diminuição de carga horária,
          iniciou férias de profissionais, implantou home office para atividades onde havia possibilidade, isolou
          ativamente as pessoas mapeadas como Grupo de maior Risco. Além destas, medidas como uso de máscaras,
          protocolos de distanciamento social através de demarcações no solo e nos mobiliários e objetos,
          disponibilização de álcool em gel nos ambientes de trabalho e massivas comunicações sobre a atualização das
          informações referentes à pandemia foram sendo feitas conforme novos boletins epidemiológicos, notas técnicas e
          demais comunicações dos órgãos competentes como: Organização Mundial da Saúde, Ministério da Saúde e ANVISA
          foram disponibilizados.
        </Text>
        <Text>
          Em 17/03/2020, para auxiliar o reporte de quais funcionários estavam com suspeitas ou sintomas do Coronavírus,
          ou ainda que estavam retornando de viagens do exterior, ainda que assintomáticos, foi criado o Hotsite
          Coronavírus, tendo possibilidade de acesso de qualquer local, e inclusive na Intranet do Banco.
        </Text>
        <Text>
          Tão logo da autorização legal do governo como atividade essencial, e ainda na tentativa de não impactar no
          aumento de casos ou na demanda ao sistema de saúde, implantou-se a partir de 22/04/2020 o protocolo de
          Telemedicina 24h/7 dias na semana para 100% dos funcionários da instituição sendo estendido para os
          dependentes em Julho/2020, de modo que qualquer dúvida ou sintoma poderia ter sua conduta avaliada e definida
          por um médico treinado e certificado.
        </Text>
        <Text>
          Importante que se diga que não houve mudança de protocolo médico na condução dos casos confirmados tampouco
          dos contatantes. Permanecemos respeitando as definições das autoridades médicas e Ministério da Saúde,
          acatando sempre a conduta médica para cada caso avaliado.
        </Text>
        <Text>
          A partir de 26/05/2020, com as novas definições sobre quarentena, aplicações do protocolo Lockdown em algumas
          cidades enquanto em outras partindo para uma nova fase da quarentena com necessidades econômicas e de
          reabertura dos estabelecimentos e volta das rotinas, as novas condições de isolamento são definidas através do
          conceito de exposição de acordo com o Ministério da Saúde:
        </Text>
        <Text>
          <ol>
            <li>
              Uma pessoa que teve contato frente a frente por 15 minutos ou mais e a uma distância inferior a 2 metros
            </li>
            <li>
              Uma pessoa que esteve em um ambiente fechado (por exemplo, sala de aula, sala de reunião, sala de espera
              do hospital etc.) por 15 minutos ou mais e a uma distância inferior a 2 metros
            </li>
            <li>
              A avaliação do grau de exposição do contato deve ser individualizada, considerando-se o ambiente e o tempo
              de exposição.
            </li>
          </ol>
        </Text>
        <Text>
          Em 18/06/2020 quando instaurada a Portaria 20, a Unimed revisitou novamente seus processos, adotando os
          seguintes conceitos:
        </Text>
        <Text>
          <ul>
            <li>
              Considera-se <b>Caso Confirmado</b> colaboradores com resultado de exame laboratorial confirmando a
              COVID-19 ou que entregaram atestado médico com CID B34.2. Para esse grupo preconiza-se o isolamento por 14
              dias e, sendo que nos casos em que a confirmação laboratorial se deu por Teste Rápido ou Sorológico,
              solicita-se a contraprova confirmatória com exame molecular (RT-PCR por swab nasal para Coronavírus), já
              que este é o exame padrão ouro para o diagnóstico de infecção ativa do COVID-19 segundo Ministério da
              Saúde;
            </li>
            <li>
              Considera-se <b>Caso Suspeito</b> colaboradores que apresentem quadro respiratório agudo com um ou mais
              dos sinais ou sintomas: febre, tosse, dor de garganta, coriza e falta de ar, entre outros sintomas
              gripais. Para esse grupo recomenda-se busca imediata de consulta médica via Telemedicina para que o médico
              analise a situação individual e defina a conduta: se exame molecular para COVID e/ou isolamento
              preventivo;
            </li>
            <li>
              Considera-se <b>contatante</b> colaboradores assintomáticos que tiveram contato com o caso confirmado da
              COVID-19, entre dois dias antes e quatorze dias após o início dos sinais e sintomas ou da confirmação
              laboratorial, em uma das situações abaixo:
            </li>
          </ul>
          <ul>
            <ol>a) ter contato durante mais de quinze minutos a menos de um metro de distância </ol>
            <ol>b) compartilhar o mesmo ambiente domiciliar</ol>
          </ul>
        </Text>
        <Text>
          Considerando as medidas de distanciamento (maior de 1 metro), uso de máscaras e novas formas de trabalho:
          remoto, reuniões por vídeo e etc., os conviventes de um mesmo ambiente físico de trabalho seriam considerados
          suspeitos apenas se sintomáticos. No entanto, para fins de vigilância epidemiológica, adotou-se o protocolo de
          testagem de todo funcionário que teve contato com caso positivo confirmado com exame laboratorial para
          COVID-19 dentro de seu ambiente. Casos assintomáticos são testados com Teste Rápido, e àqueles sintomáticos,
          passam a ser Casos Suspeitos e são testados com a prova molecular.
        </Text>
        <Text>Desta maneira, o fluxo operacional, segue da seguinte forma:</Text>
        <Text>
          <ol>
            1. O Gestor através do Portal de RH preenche o formulário informando o funcionário positivo e todos os seus
            contatantes conforme modelo abaixo. Automaticamente, o local de trabalho é sanitizado através do protocolo
            estabelecido pela área de Premisses e Facilities.
            <br />
            <br />
            <table>
              <tr>
                <td>
                  <Image
                    src="/pdfs/template-sso/pgr_image_1.png"
                    maxWidth={250}
                    style={{ margin: 'auto' }}
                    ignoreFixedSize
                  />
                </td>
                <td>
                  <Image
                    src="/pdfs/template-sso/pgr_image_3.png"
                    maxWidth={245}
                    style={{ margin: 'auto' }}
                    ignoreFixedSize
                  />
                </td>
              </tr>
            </table>
            <Text size="small" align={'center'}>
              Modelo do formulário para cadastro de contatantes – disponível no Portal RH (intranet) e App As Pessoas
            </Text>
          </ol>
          <ol>
            2. A equipe técnica tem matriz de decisão abaixo, para solicitação de testes e isolamento.
            <br />
            <Image src="/pdfs/template-sso/pgr_image_2.png" maxWidth={550} style={{ margin: 'auto' }} ignoreFixedSize />
          </ol>
        </Text>
        <Text>
          É importante destacar que todos os pedidos de exames/testes solicitados pela área de Saúde e Segurança do
          Trabalho aos funcionários são reembolsáveis, através de protocolo previamente estabelecido e comunicado.
        </Text>
        <Text>
          Todos os fluxos e processos são revisitados periodicamente e sempre que necessário realizamos alguma
          alteração. O documento oficial contendo todas as evidências e protocolos das ações realizadas foi elaborado a
          parte, sendo este disponibilizado sempre que requisitado.
        </Text>
        <Text>
          Este documento ressalta:
          <ul>
            <li>Definição dos papéis e responsabilidades de cada área frente à Pandemia</li>
            <li>Fluxo de disponibilização de máscaras e álcool em gel nas agências</li>
            <li>Protocolos de higienização e desinfecção dos ambientes</li>
            <li>Higienização das mãos uso obrigatório de máscaras</li>
            <li>Definição dos grupos de maior risco por classificação da criticidade</li>
            <li>Protocolos de distanciamento social e controle populacional na rede de agências e áreas centrais</li>
            <li>Comunicados oficiais do Presidente da Unimed</li>
            <li>Protocolos de saúde atualizado conforme evolução da pandemia no Brasil</li>
            <li>Hotsite e formulários de monitoramento e reporte de casos suspeitos e confirmados</li>
            <li>FAQ – duvidas frequentes e atualizações do COVID-19</li>
            <li>Evidências sobre a campanha de vacinação</li>
            <li>Treinamento e orientação às CIPAs sobre como proceder durante a pandemia</li>
            <li>Revisão e alteração dos protocolos de saúde e segurança</li>
          </ul>
        </Text>
        <Text>
          Em complemento faz-se observar que o Anexo 14 da NR 15 define as atividades que estão em contato com{' '}
          <b>AGENTES BIOLÓGICOS</b>
        </Text>
        <Text>
          <i>
            <ul>
              <ol>
                - pacientes em isolamento por doenças infectocontagiosas, bem como objetos de seu uso, não previamente
                esterilizados;
              </ol>
              <ol>
                - carnes, glândulas, vísceras, sangue, ossos, couros, pelos e dejeções de animais portadores de doenças
                infectocontagiosas (carbunculose, brucelose, tuberculose); - esgotos (galerias e tanques);
              </ol>
              <ol>- lixo urbano (coleta e industrialização).</ol>
              <ol>
                - hospitais, serviços de emergência, enfermarias, ambulatórios, postos de vacinação e outros
                estabelecimentos destinados aos cuidados da saúde humana (aplica-se unicamente ao pessoal que tenha
                contato com os pacientes, bem como aos que manuseiam objetos de uso Este texto não substitui o publicado
                no DOU desses pacientes, não previamente esterilizados);
              </ol>
              <ol>
                - hospitais, ambulatórios, postos de vacinação e outros estabelecimentos destinados ao atendimento e
                tratamento de animais (aplica-se apenas ao pessoal que tenha contato com tais animais);
              </ol>
              <ol>- contato em laboratórios, com animais destinados ao preparo de soro, vacinas e outros produtos;</ol>
              <ol>- laboratórios de análise clínica e histopatologia (aplica-se tão-só ao pessoal técnico);</ol>
              <ol>
                - gabinetes de autópsias, de anatomia e histoanatomopatologia (aplica-se somente ao pessoal técnico);
              </ol>
              <ol>- cemitérios (exumação de corpos);</ol>
              <ol>- estábulos e cavalariças;</ol>
              <ol>- resíduos de animais deteriorados.</ol>
            </ul>
          </i>
        </Text>
        <Text>
          O PCMSO é implantado com base nos riscos à saúde dos trabalhadores previstos no PPRA, na definição das
          atividades/ grau de concentração preestabelecidos na NR 15 (quando há exposição a riscos caracterizados na NR
          9) e nos Anexos I e II da NR 7. Sendo assim fica clara a inexistência de riscos ocupacionais específicos, uma
          vez que a atividade bancária não contempla nenhum dos casos supracitados.
        </Text>
      </View>
      <Text bold align={'center'} id={'8.2'}>
        ANEXO II – CERTIFICADOS DE CALIBRAÇÃO DOS EQUIPAMENTOS
      </Text>
      <>
        {certifyImages.length ? (
          certifyImages.map((image, index) => (
            <Image style={{ margin: 'auto' }} maxHeight={850} key={index} src={image.src} ignoreFixedSize />
          ))
        ) : (
          <Text align={'center'}>Não encontrado</Text>
        )}
      </>
      <Separator weight={8} />
    </View>
  )
}
export default AttachmentsSection
